import * as React from "react";

interface FileDownloadProps {
    className?: string;
    onClick?: () => void;
}

export function FileDownload(props: FileDownloadProps) {
    return (
        <div {...props}>
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_8111_53119)">
                    <path
                        d="M18.75 12H21.25C21.6656 12 22 12.3344 22 12.75V18H24.7406C25.2969 18 25.575 18.6719 25.1812 19.0656L20.4281 23.8219C20.1938 24.0562 19.8094 24.0562 19.575 23.8219L14.8156 19.0656C14.4219 18.6719 14.7 18 15.2562 18H18V12.75C18 12.3344 18.3344 12 18.75 12ZM28 23.75V27.25C28 27.6656 27.6656 28 27.25 28H12.75C12.3344 28 12 27.6656 12 27.25V23.75C12 23.3344 12.3344 23 12.75 23H17.3344L18.8656 24.5312C19.4938 25.1594 20.5062 25.1594 21.1344 24.5312L22.6656 23H27.25C27.6656 23 28 23.3344 28 23.75ZM24.125 26.5C24.125 26.1562 23.8438 25.875 23.5 25.875C23.1562 25.875 22.875 26.1562 22.875 26.5C22.875 26.8438 23.1562 27.125 23.5 27.125C23.8438 27.125 24.125 26.8438 24.125 26.5ZM26.125 26.5C26.125 26.1562 25.8438 25.875 25.5 25.875C25.1562 25.875 24.875 26.1562 24.875 26.5C24.875 26.8438 25.1562 27.125 25.5 27.125C25.8438 27.125 26.125 26.8438 26.125 26.5Z"
                        fill="#00608C"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_8111_53119">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(12 12)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
}
